module.exports = __webpack_public_path__ + "img/bg_patrol_02.cd504488.jpg";